import {
  FaTachometerAlt,
  FaUsers,
  FaBook,
  FaBookOpen,
  FaCalendarAlt,
  FaUmbrellaBeach,
  FaGraduationCap,
  FaChartBar,
  FaCalendarDay,
  FaFont,
  FaQuestionCircle,
  FaRupeeSign,
  FaBullhorn,
  FaNewspaper,
  FaCalendarCheck,
} from "react-icons/fa";

const item = (Icon, label, to) => ({
  label,
  to,
  name: (
    <div className="sp-sidebar-nav-content">
      <Icon />
      <span>{label}</span>
    </div>
  ),
});

// Mirrors the order of the Figma "Parent App" sidebar. Each `to` is an
// absolute path handled by StudentPortalRoutes.js.
export const studentNav = [
  item(FaTachometerAlt, "Dashboard", "/student-portal/dashboard"),
  item(FaUsers, "Attendance", "/student-portal/attendance"),
  item(FaBook, "Homework", "/student-portal/homework"),
  item(FaBookOpen, "Syllabus", "/student-portal/syllabus"),
  item(FaCalendarAlt, "Timetable", "/student-portal/timetable"),
  item(FaUmbrellaBeach, "Leaves", "/student-portal/leaves"),
  item(FaGraduationCap, "Courses", "/student-portal/courses"),
  item(FaChartBar, "Result", "/student-portal/result"),
  item(FaCalendarDay, "Events", "/student-portal/events"),
  item(FaFont, "Word of the Day", "/student-portal/word-of-the-day"),
  item(FaQuestionCircle, "FAQs", "/student-portal/faq"),
  item(FaRupeeSign, "Fees", "/student-portal/fees"),
  item(FaBullhorn, "Circulars", "/student-portal/circulars"),
  item(FaNewspaper, "Newsroom", "/student-portal/newsroom"),
  item(FaCalendarCheck, "Appointments", "/student-portal/appointments"),
];
